import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ReactPaginate from "react-paginate";
import { TableConfig } from "../../config/Config";
import "./index.modules.scss";

export function PaginationV2({ totalPages, currentPage, handlePageClick }) {
  const activePage = Math.max(0, (currentPage || 1) - 1);

  if (totalPages <= 1) return null;

  return (
    <div className="paginationWrapper">
      <ReactPaginate
        previousLabel={
          <ArrowBackIosIcon style={{ fontSize: 16 }} aria-label="Previous page" />
        }
        nextLabel={
          <ArrowForwardIosIcon style={{ fontSize: 16 }} aria-label="Next page" />
        }
        breakLabel="..."
        pageCount={totalPages}
        forcePage={activePage}
        marginPagesDisplayed={1}
        pageRangeDisplayed={TableConfig.pageRangeDisplayed}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
        disabledClassName="disabled"
      />
    </div>
  );
}